import React from 'react';
import { useTranslation } from 'react-i18next';

interface SearchButtonProps {
  testId?: string;
  className?: string;
  handleClick?: () => void;
}

export const SearchButton: React.FC<SearchButtonProps> = ({
  testId,
  className,
  handleClick,
}) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`noto-13-normal flex h-[36px] w-[100px] cursor-pointer items-center justify-center rounded-[5px] bg-teal-dark text-white ${className}`}
      onClick={handleClick}
    >
      {t('settlement.searchButton')}
    </div>
  );
};
